module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_jordan_08.76ec31b0.jpg";